<template>
  <div class="page">
    <div class="title-row">
      <span class="page-title">班次设置</span>
      <el-button type="primary" size="small" @click="openAdd">
        <i class="el-icon-plus"></i> 新增班次
      </el-button>
    </div>

    <div class="tip-bar">
      <i class="el-icon-info" style="color:#2563EB;font-size:14px;flex-shrink:0;margin-right:8px"></i>
      班次设置的数据将在新增排班时作为选项使用，删除班次前请确保没有排班引用该班次。
    </div>

    <div class="main-card">
      <el-table :data="shiftList" :border="false" style="width:100%">
        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
        <el-table-column label="班次名称" width="140">
          <template slot-scope="{ row }">
            <div style="display:flex;align-items:center;">
              <span class="shift-dot" :style="{ background: row.color || '#2563EB' }"></span>
              <span style="font-weight:500;color:#1E293B;margin-left:8px">{{ row.name }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="开始时间" width="120">
          <template slot-scope="{ row }">{{ getStartTime(row.time) }}</template>
        </el-table-column>
        <el-table-column label="结束时间" width="120">
          <template slot-scope="{ row }">{{ getEndTime(row.time) }}</template>
        </el-table-column>
        <el-table-column label="时长" width="100">
          <template slot-scope="{ row }">
            <span style="color:#64748B">{{ getDuration(row.time) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="标识颜色" width="100">
          <template slot-scope="{ row }">
            <span class="color-block" :style="{ background: row.color || '#2563EB' }"></span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="140">
          <template slot-scope="{ row }">
            <el-button size="mini" style="background:#EFF6FF;color:#2563EB;border-color:#BFDBFE" @click="openEdit(row)">
              <i class="el-icon-edit"></i> 编辑
            </el-button>
            <el-button size="mini" style="background:#FEF2F2;color:#EF4444;border-color:#FECACA;margin-left:6px" @click="handleDelete(row.id)">
              <i class="el-icon-delete"></i> 删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 新增/编辑弹窗 -->
    <el-dialog
      :title="editingId ? '编辑班次' : '新增班次'"
      :visible.sync="modalVisible"
      width="480px"
      :append-to-body="true">
      <el-form :model="form" label-width="80px" style="margin-top:8px">
        <el-form-item label="班次名称" required>
          <el-input v-model="form.name" placeholder="如：早班、中班、晚班、夜班、白班" clearable></el-input>
        </el-form-item>
        <el-form-item label="班次时间" required>
          <div class="time-row">
            <el-time-picker v-model="form.startTime" format="HH:mm" value-format="HH:mm" placeholder="开始时间" style="flex:1"></el-time-picker>
            <span style="color:#94A3B8;padding:0 8px">至</span>
            <el-time-picker v-model="form.endTime" format="HH:mm" value-format="HH:mm" placeholder="结束时间" style="flex:1"></el-time-picker>
          </div>
          <div v-if="form.startTime && form.endTime" class="time-tip">
            <i class="el-icon-circle-check" style="color:#10B981;font-size:13px;margin-right:5px"></i>
            共计 {{ calcDuration(form.startTime, form.endTime) }}（含跨夜计算）
          </div>
        </el-form-item>
        <el-form-item label="标识颜色">
          <div class="color-picker">
            <span
              v-for="c in colorOptions"
              :key="c"
              class="color-option"
              :style="{ background: c }"
              :class="{ active: form.color === c }"
              @click="form.color = c">
              <i v-if="form.color === c" class="el-icon-check" style="color:#fff;font-size:12px"></i>
            </span>
            <span class="color-hex">{{ form.color }}</span>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="modalVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">保存班次</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getShiftList, addShift, editShift, deleteShift } from './scheduleApi'
import { calcDuration } from './scheduleUtils'

const COLOR_OPTIONS = [
  '#2563EB', '#10B981', '#7C3AED', '#F59E0B', '#EF4444',
  '#06B6D4', '#EC4899', '#84CC16', '#F97316', '#6366F1'
]

export default {
  name: 'ShiftSetting',
  data() {
    return {
      shiftList: [],
      colorOptions: COLOR_OPTIONS,
      modalVisible: false,
      editingId: null,
      form: { name: '', startTime: '', endTime: '', color: '#2563EB' }
    }
  },
  mounted() {
    this.loadShifts()
  },
  methods: {
    calcDuration,
    getStartTime(time) { return time ? time.split('-')[0] : '' },
    getEndTime(time) { return time ? time.split('-')[1] : '' },
    getDuration(time) {
      if (!time) return ''
      const [s, e] = time.split('-')
      return calcDuration(s, e)
    },
    openAdd() {
      this.editingId = null
      Object.assign(this.form, { name: '', startTime: '', endTime: '', color: '#2563EB' })
      this.modalVisible = true
    },
    openEdit(record) {
      this.editingId = record.id
      const [s, e] = (record.time || '-').split('-')
      Object.assign(this.form, { name: record.name, startTime: s || '', endTime: e || '', color: record.color || '#2563EB' })
      this.modalVisible = true
    },
    async handleSubmit() {
      if (!this.form.name.trim()) { this.$message.warning('请输入班次名称'); return }
      if (!this.form.startTime || !this.form.endTime) { this.$message.warning('请选择班次时间'); return }
      const payload = { name: this.form.name, time: `${this.form.startTime}-${this.form.endTime}`, color: this.form.color }
      const res = this.editingId
        ? await editShift({ ...payload, id: this.editingId })
        : await addShift(payload)
      if (res && res.code == 200) {
        this.$message.success(this.editingId ? '修改成功' : '新增成功')
        this.modalVisible = false
        this.loadShifts()
      }
    },
    handleDelete(id) {
      this.$confirm('删除后该班次将无法在排班中使用，确认删除？', '确认删除', {
        confirmButtonText: '确认删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await deleteShift(id)
        if (res && res.code == 200) { this.$message.success('删除成功'); this.loadShifts() }
      }).catch(() => {})
    },
    async loadShifts() {
      const res = await getShiftList()
      if (res && res.code == 200) {
        const data = res.result || res
        this.shiftList = Array.isArray(data) ? data : (data.list || data.records || [])
      }
    }
  }
}
</script>

<style scoped>
.page { padding: 0 16px; height: calc(100vh - 56px); display: flex; flex-direction: column; overflow: hidden; }
.title-row { display: flex; justify-content: space-between; align-items: center; flex-shrink: 0; padding: 8px 0 4px; }
.page-title { font-size: 18px; font-weight: 700; color: #1E293B; }
.tip-bar { display: flex; align-items: center; padding: 10px 14px; border-radius: 8px; background: #EFF6FF; border: 1px solid #BFDBFE; font-size: 13px; color: #1E40AF; flex-shrink: 0; margin-bottom: 8px; }
.main-card { flex: 1; min-height: 0; overflow-y: auto; background: #fff; border-radius: 10px; border: 1px solid #E2E8F0; box-shadow: 0 1px 6px rgba(0,0,0,0.04); }
.shift-dot { width: 10px; height: 10px; border-radius: 50%; flex-shrink: 0; display: inline-block; }
.color-block { width: 20px; height: 20px; border-radius: 4px; display: inline-block; }
.time-row { display: flex; align-items: center; }
.time-tip { display: flex; align-items: center; margin-top: 6px; font-size: 12px; color: #10B981; }
.color-picker { display: flex; align-items: center; flex-wrap: wrap; }
.color-picker > * { margin-right: 8px; margin-bottom: 4px; }
.color-option { width: 28px; height: 28px; border-radius: 6px; cursor: pointer; display: flex; align-items: center; justify-content: center; border: 2px solid transparent; }
.color-option:hover { transform: scale(1.1); }
.color-option.active { border-color: #1E293B; }
.color-hex { font-size: 12px; color: #64748B; margin-left: 4px; }
</style>
